var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-box-title{margin-top:-3rem;height:1.6rem;background:url(" + escape(require("../../static/img/icon-prompt-pop-up.png")) + ") no-repeat;background-size:30%;background-position:bottom}.message-pop-content{word-wrap:break-word;width:80%;height:40%;position:absolute;top:30%;left:10%;right:0}.message-box-title{text-align:center;background-color:#39c451;height:2.25rem;line-height:2.25rem;padding-left:.75rem;padding-right:.75rem}.message-scroll{position:absolute;top:2.25rem;bottom:0;overflow-y:auto;padding:0}.popup-message-box{position:fixed;top:0;left:0;right:0;bottom:0;overflow-y:auto;text-align:left;color:#444;background-color:rgba(0,0,0,.7);z-index:4;list-style:none}.right-fork{width:.7rem;height:.675rem;background:url(" + escape(require("../../static/img/pop-btn.png")) + ") no-repeat;background-size:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b648308","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ConfirmListBox.vue
// module id = 453
// module chunks = 0